import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import Button from '../Elements/Button/Button';

export default function AccessDenied() {
    const navigate = useNavigate();

    return (
        <div
            className='container-mh'
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
                padding: '20px'
            }}
        >
            <div
                style={{
                    maxWidth: 480,
                    padding: '40px 20px',
                    textAlign: 'center',
                    background: '#fff',
                    borderRadius: 12,
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
                    border: '1px solid #e0e0e0',
                }}
            >
                <Lock size={48} style={{ color: '#e15759', marginBottom: 20 }} />
                <h2 style={{ fontSize: '1.75rem', marginBottom: 12, color: '#333' }}>
                    Acceso denegado
                </h2>
                <p style={{ fontSize: '1rem', color: '#666', lineHeight: 1.5 }}>
                    No tienes permiso para ver esta página.
                </p>
                <Button
                    text="Volver al inicio"
                    color="blue"
                    fill
                    action={() => navigate('/')}
                    classNames="mt-4"
                />
            </div>
        </div>
    );
}
